module.exports = __webpack_public_path__ + "static/media/upvote-blue.c6e9b761.svg";